import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { useResume } from '../../context/ResumeContext';
import { FINAL_RESUME, DEFAULT_TEMPLATE_COLOR, POPUP_TYPES, PAID_SERVICES, MEMBERSHIP, DEFAULT_VARIANT_COLOR, OLD_COLOR_CODES, COVERLETTER_EXPERIENCE, APP_DOMAIN } from '../../constants/constants';
import WpAPI from '../../WpApi';
import { usePopup } from '../../context/PopupContext';
import SignUpPopup from '../user/SignUpPopup';
import downloadResume from '../../downloadResume';
import { ChromePicker } from 'react-color';
import IconGrid from '../../assets/images-new/icons/window-grid.svg';
import PreviewIcon from '../../assets/images-new/icons/visibility.svg';
import DownloadIcon from '../../assets/images-new/icons/download-icon.svg';
import { userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction } from '../../services/actions/actions';
import { removeBodyScroll } from '../../helper';
import { useUser } from '../../context/UserContext';
const BottomControls = (props) => {
    const dispatch = useDispatch();
    const popupbox = usePopup();
    const history = useHistory();
    const [spinner, setSpinner] = useState(false);
    const ddRef = useRef();
    const [templateColor, setTemplateColor] = useState('');
    const [saved, setSaved] = useState(false);
    const [showLoginPopUp, setShowLoginPopUp] =  useState(false);
    const [loader, setLoader] = useState({download: false, saveSpoof: false, share: false});
    const [toggleColorPicker, setToggleColorPicker] = useState(false);

    const {
        checkMembership,
        plan,
        user
    } = useUser();

    const {
        resume,
        setShowPreview,
        handlers: {
            updateResumePreview,
            //nuteralizeNextClick,
            //nuteralizeBackClick,
            onsaveResume,
            //deleteSection,
        },
        currentResume
    } = useResume();

    const mounted = useRef(false);

    // useEffect(() => {
    //     props.setShowBeforeUnload(true);
    //     return () => {
    //         props.setShowBeforeUnload(false);
    //     }
    // }, [props.setShowBeforeUnload]);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    const saveSpoof = () => {
        onsaveResume();
        let isLoggedIn = WpAPI.isLoggedIn();
        if(isLoggedIn){
            //setTemplateColor('#FFFFFF');
            //updateResumePreview({ custom_template_color: '' });
            {/** START: chnages for #858 */}
            if(mounted.current) setSaved(true);
            // if(PAID_SERVICES){
            //     if(plan == 'pro'){
            //         onsaveResume();
            //         setSaved(true);
            //     }else{
            //         history.push(MEMBERSHIP)
            //     }
            // }else{
            //     onsaveResume();
            //     setSaved(true);
            // }
            {/** END */}
        }else{
            //onsaveResume(); //changes for #858
            setShowLoginPopUp(true);
            WpAPI.setRedirectCookie(location.pathname);
            gaTrack('RT App', `Editor`, `Login/Signup Popup`);
            ga4Track('app_editor_save_button_popup', 'RT App', 'Login/Signup Popup');
        }
        gaTrack('RT App', `Editor`, `Save Resume`);
        ga4Track('app_editor_save', 'RT App', 'Save Resume');
        ga4Track('app_bottom_nav_save', 'RT App', 'Bottom Nav: Save');
    }

    const getTemplateColorCode = () => {
        // return templateColor ? templateColor : (resume?.active_color ? DEFAULT_VARIANT_COLOR[resume?.active_color] : DEFAULT_TEMPLATE_COLOR[resume?.active_template]);
        if(DEFAULT_VARIANT_COLOR[OLD_COLOR_CODES[resume.active_color]] == undefined){
            return templateColor ? templateColor : (resume?.active_color ? DEFAULT_VARIANT_COLOR[resume?.active_color] : DEFAULT_TEMPLATE_COLOR[resume?.active_template]);
        } else {
            return templateColor ? templateColor : (resume?.active_color ? DEFAULT_VARIANT_COLOR[OLD_COLOR_CODES[resume.active_color]] : DEFAULT_TEMPLATE_COLOR[resume?.active_template]);
        }
    }

    const downloadHandler = (downloadFormat) => {
        downloadResume({resume, currentResume, user}, user, () => { 
            popupbox.close('download'); 
            popupbox.show('askfor_trustpilot_review', null, () => {
                window.open( `https://www.trustpilot.com/review/resumetemplates.com`, '_blank');
            });
        }, downloadFormat, {type: 'resume', name: 'Resume' });
    }

    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
    }, []);

    useEffect(() => {
        if (resume.custom_template_color != '') {
            if(mounted.current) setTemplateColor(resume.custom_template_color);
            //fetchAccountInfo();
        }
    }, [resume.custom_template_color]);

    if (saved) {
        setTimeout(() => {
            if(mounted.current) setSaved(false);
        }, 2000);
    }

    const onClickOutside = (e) => {
        let wrap = e.target.className;
        if (wrap.length && mounted.current) {
            setToggleColorPicker(false);
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ddRef.current && !ddRef.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);

    const userCompletesSectionsDownloadsPrintsOrShares = () => {
        dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction({...resume}, 'currentResume')).then(res => {
            if(res.completed){
                const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
                const el = (
                    PAID_SERVICES && plan == 'pro' 
                    ? 'User completes sections: Downloads, Prints or Shares' 
                    : 'Free user completes sections: tries to download, print, share'
                );
                ga4Track(ec, 'RT App', el)
            }
        })
      }

    const download = () => {
        onsaveResume();
        localStorage.setItem('clickAction', 'download');
        if(WpAPI.isLoggedIn()){
            // if(PAID_SERVICES){
            //     if(plan == 'pro'){
            //         popupbox.show('download', null, () => downloadHandler())
            //     }else history.push(MEMBERSHIP);
            // }else{
            //     popupbox.show('download', null, () => downloadHandler())
            // }
            /**
             * #775: Any logged in users can download the resume in the text format. 
             * Action: Removed the above code snippet having PAID_SERVICES and plan check.
             * Date: 2023-07-21
             */
            popupbox.show('download', null, (params) => {
                downloadHandler(params.downloadFormat);
                userCompletesSectionsDownloadsPrintsOrShares();
                // gaTrack('RT App', `Quick Editor`, 'Header Download');
                // ga4Track('app_header_download', 'RT App', 'Header Download');
                ga4Track('app_bottom_nav_download', 'RT App', 'Bottom Nav: Download');
            }, {plan: plan, entity: {type: 'resume', name: 'Resume' }});
        }else{
            setShowLoginPopUp(true);
            WpAPI.setRedirectCookie(location.pathname);
        }
    }

    const checkMembershipAction = (callback = false, params = false) => {
        if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
                callback(params);
                if(mounted.current) setLoader({...loader, [callback.name]: false});
            }
        });
    }

    return (<div className="bottom-controls-wrap">
        <div className="bottom-controls">
            {/* <div className="button button-1">
                <div className="change-templ-action">
                    <span onClick={() => history.push({
                        pathname: FINAL_RESUME,
                        state: {
                            openPanel: true,
                            referrer: `${history.location.pathname}`
                        }
                    })}><i className="icon-grid"></i>Templates</span>
                </div>
            </div> */}
            <div className="button button-2">
                <div className="templ-action">
                    <div className="change-templ-action round-btn round-btn-border"
                        onClick={() => {
                        history.push({
                            pathname: FINAL_RESUME,
                            state: {
                                openPanel: true,
                                referrer: `${history.location.pathname}`
                            }
                        });
                        ga4Track('app_bottom_nav_templates', 'RT App', 'Bottom Nav: Templates');
                        }}>
                       <i className="new-icon-grid"><IconGrid /></i> <span>Templates</span>
                    </div>
                    {/* <label htmlFor="template-color">Template Color:</label> */}
                    <div className="color-picker" onClick={() => {
                        setToggleColorPicker(true);
                    }}>
                        <span className="picker">
                            {<i className="color-square" style={{ backgroundColor: getTemplateColorCode() }}></i>}
                            {/* <input type="color" name="template-color" value={templateColor ? templateColor : DEFAULT_VARIANT_COLOR[resume?.active_color]}
                            onChange={(e) => {
                                setTemplateColor(e.target.value);
                                updateResumePreview({ custom_template_color: e.target.value });
                                onsaveResume();
                            }} /> */}
                        </span>
                        {toggleColorPicker ? <div className="chrome-picker" ref={ddRef}> <ChromePicker
                            color={getTemplateColorCode()}
                            onChange={(e) => { setTemplateColor(e.hex) }}
                            onChangeComplete={(e) => {
                                setTemplateColor(e.hex);
                                updateResumePreview({ custom_template_color: e.hex });
                                onsaveResume();
                            }}
                            disableAlpha={true}
                        /> </div> : ''}



                        <span className="color-code">{getTemplateColorCode()}</span>
                        {/* <span className="cross" onClick={() => {
                            updateResumePreview({ custom_template_color: '' });
                            onsaveResume();
                        }}><i className="icon-cross-icon"></i></span> */}
                    </div>
                </div>
            </div>
            <div className="button button-3">
                <div className="button-link round-btn round-btn-border" onClick={()=>{
                    setShowPreview(true);
                    removeBodyScroll(true);
                    ga4Track('app_editor_preview', 'RT App', 'Preview');
                    ga4Track('app_bottom_nav_preview', 'RT App', 'Bottom Nav: Preview');
                }}>
                    <i className="new-icon-eye"><PreviewIcon /></i>Preview
                </div>
                <div className={`save-action round-btn round-btn-border ${saved ? ' green' : ''}`}
                    onClick={() => {checkMembershipAction(saveSpoof)}}>
                        {saved ? <>
                        <i className="icon-tick-light"></i>Saved!</> : <><i className="icon-save"></i>
                        {loader.save ? 'Loading...' : 'Save'}</>}
                </div>
                <div className="download-btn round-btn round-btn-border" onClick={() => {checkMembershipAction(download)}}>
                    <i className="new-icon-download"><DownloadIcon /></i> {loader.download ? 'Loading...' : 'Download'}
                </div>
            </div>
        </div>
        {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} /> : ''}
    </div>);
}

export default BottomControls;